export default "{\n    \"header\": \"Point de contact\",\n    \"fullName\": \"Nom complet\",\n    \"phoneNumber\": \"Numéro de téléphone\"\n}\n"